// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b5f9c7eb","453":"e9d894d2","455":"21a90b9b"}[chunkId] + ".chunk.js";
};